import { createContext } from "solid-js";

interface AppLayoutContextValue {
  activeDragId: () => string | null;
  committedPath: () => string;
}

export const AppLayoutContext = createContext<AppLayoutContextValue>();
